import React from 'react'
import './close.css'

export default function Close({ offset, onClick }) {

    function handleClick(e) {
        if (onClick) {
            onClick(e)
        }
    }

    const buttonOffset = offset ? ' closeButton--offset' : ''

    return (
        <div onClick={handleClick} className={`closeButton${buttonOffset}`}>
            <i className='material-icons'>close</i>
        </div>
    )

}


// WEBPACK FOOTER //
// ./src/components/Close/index.js